import config from '../config';
import { ImageSize, Image, ImageSizeConfig } from '../types/Image';

export const imageSizeConfigs: Partial<Record<ImageSize, ImageSizeConfig>> = {
  [ImageSize.Square20]: {
    width: 20,
    height: 20
  },
  [ImageSize.Square20Inscribed]: {
    maxWidth: 20,
    maxHeight: 20
  },
  [ImageSize.Square50]: {
    width: 50,
    height: 50
  },
  [ImageSize.Rect80x60Inscribed]: {
    maxWidth: 80,
    maxHeight: 60
  },
  [ImageSize.Square80]: {
    width: 80,
    height: 80
  },
  [ImageSize.Rect133x100InscribedWithEnlarge]: {
    maxWidth: 133,
    maxHeight: 100
  },
  [ImageSize.Rect160x120InscribedWithEnlarge]: {
    maxWidth: 160,
    maxHeight: 120
  },
  [ImageSize.Rect200x150InscribedWithEnlarge]: {
    maxWidth: 200,
    maxHeight: 150
  },
  [ImageSize.Square300InscribedWithEnlarge]: {
    maxWidth: 300,
    maxHeight: 300
  },
  [ImageSize.Square400InscribedWithEnlarge]: {
    maxWidth: 400,
    maxHeight: 400
  }
};

// Backward compatibility alias
export const imageSizes = imageSizeConfigs;

export const buildImageUrl = (image: Image, size: ImageSize | string): string => {
  return `${config().universal.imagesBaseUrl}/${size}/${image.filename}`;
};

export const buildCityShareImageUrl = (citySlug: string): string => {
  return `${config().universal.imagesBaseUrl}/email/everyday-rides-logo-${citySlug}.png`;
}; 